import React, { useState } from 'react';
import Icon from '../Icon';
import { WmsLayer } from '@avinet/react-openlayers';
import config from '../../config/kystverket';
import './LayerSwitch.scss';

const LayerSwitch = () => {
  const [open, setOpen] = useState(true);
  const [mtrActive, setMtrActive] = useState(true);
  const [cprActive, setCprActive] = useState(true);
  const [pilotActive, setPilotActive] = useState(true);
  const [approachCorridorActive, setApproachCorridorActive] = useState(true);
  const [svalbardActive, setSvalbardActive] = useState(true);
  const [anchorageActive, setAnchorageActive] = useState(true);

  return (
    <div className={['layer-switch', open ? 'open' : ''].join(' ')}>
      <div className="layer-switch--icons" onClick={() => setOpen(!open)}>
        <Icon name="layerSwitch" />
        <Icon name={open ? 'chevronup' : 'chevrondown'} />
      </div>
      <div className="layer-switch--layers">
        <div className="layer-switch--layer">
          <input
            type="checkbox"
            id="vts"
            onChange={() => setMtrActive(!mtrActive)}
            checked={mtrActive}
          />
          <label htmlFor="vts">Local Regulations (VTS)</label>
        </div>
        <div className="layer-switch--layer">
          <input
            type="checkbox"
            id="pec"
            onChange={() => setCprActive(!cprActive)}
            checked={cprActive}
          />
          <label htmlFor="pec">Local Regulations for Use of PEC</label>
        </div>
        <div className="layer-switch--layer">
          <input
            type="checkbox"
            id="pilot"
            onChange={() => setPilotActive(!pilotActive)}
            checked={pilotActive}
          />
          <label htmlFor="pilot">Pilot Boarding</label>
        </div>
        <div className="layer-switch--layer">
          <input
            type="checkbox"
            id="approachCorridor"
            onChange={() => setApproachCorridorActive(!approachCorridorActive)}
            checked={approachCorridorActive}
          />
          <label htmlFor="approachCorridor">Approach Corridor for Pilotage</label>
        </div>
        <div className="layer-switch--layer">
          <input
            type="checkbox"
            id="svalbard"
            onChange={() => setSvalbardActive(!svalbardActive)}
            checked={svalbardActive}
          />
          <label htmlFor="svalbard">Svalbard</label>
        </div>
        {/* <div className="layer-switch--layer">
          <input
            type="checkbox"
            id="lfr"
            onChange={() => setLfrActive(!lfrActive)}
            checked={lfrActive}
          />
          <label htmlFor="lfr">Pilot Guidelines (test, all guidelines might not be included)</label>
        </div> */}
        <div className="layer-switch--layer">
          <input
            type="checkbox"
            id="anchorage"
            onChange={() => setAnchorageActive(!anchorageActive)}
            checked={anchorageActive}
          />
          <label htmlFor="anchorage">Anchorage for sea transport</label>
        </div>
      </div>
      {mtrActive && (
        <WmsLayer
          id="MTR"
          name="Local Regulations (VTS)"
          uri={config.a4WmsUrl}
          layerName={config.layerIds.mtr}
          version="1.1.1"
          singleTile
          key="mtr"
        />
      )}
      {cprActive && (
        <WmsLayer
          id="CPR"
          name="Local Regulations for Use of PEC"
          uri={config.a4WmsUrl}
          layerName={config.layerIds.cpr}
          version="1.1.1"
          singleTile
          key="cpr"
        />
      )}
      {pilotActive && (
        <WmsLayer
          id="Pilot"
          name="Pilot Boarding"
          uri={config.a4WmsUrl}
          layerName={config.layerIds.pilot}
          version="1.1.1"
          singleTile
          key="pilot"
          minZoom={9}
        />
      )}
      {approachCorridorActive && (
        <WmsLayer
          id="ApproachCorridor"
          name="Approach Corridor for Pilotage"
          uri={config.a4WmsUrl}
          layerName={config.layerIds.approachCorridor}
          version="1.1.1"
          singleTile
          key="approachCorridor"
        />
      )}
      {svalbardActive && (
        <WmsLayer
          id="Svalbard"
          name="Svalbard"
          uri={config.a4WmsUrl}
          layerName={config.layerIds.svalbard}
          version="1.1.1"
          singleTile
          key="svalbard"
        />
      )}
      {/* {lfrActive && (
        <WmsLayer
          id="LFR"
          name="Pilot Guidelines (test, all guidelines might not be included)"
          uri={config.a3WmsUrl}
          layerName={config.layerIds.lfr}
          version="1.1.1"
          singleTile
          key="lfr"
        />
      )} */}
      {anchorageActive && (
        <>
          <WmsLayer
            id="Anchorage Point"
            name="Anchorage Point"
            uri={config.a4WmsUrl}
            layerName={config.layerIds.anchoragePoint}
            version="1.1.1"
            singleTile
            key="anchoragePoint"
            zIndex={1}
          />
          <WmsLayer
            id="Anchorage Area"
            name="Anchorage Area"
            uri={config.a4WmsUrl}
            layerName={config.layerIds.anchorageArea}
            version="1.1.1"
            singleTile
            key="anchorageArea"
          />
          <WmsLayer
            id="Anchorage Area - centerpoint"
            name="Anchorage Area - centerpoint"
            uri={config.a4WmsUrl}
            layerName={config.layerIds.anchorageAreaCenterpoint}
            version="1.1.1"
            singleTile
            key="anchorageAreaCenterpoint"
            zIndex={1}
          />
        </>
      )}
    </div>
  );
};

export default LayerSwitch;
